import { IFamilyTree } from './family-tree.model';

export interface FamilyTreeState {
  familyTrees: IFamilyTree[];
  initialLoad: boolean;
  loader: boolean;
}

export const initialState: FamilyTreeState = {
  familyTrees: null,
  initialLoad: true,
  loader: false,
};
